import { render } from "./BaseIconHarddrinks.vue?vue&type=template&id=9a06b08a"
import script from "./BaseIconHarddrinks.vue?vue&type=script&lang=js"
export * from "./BaseIconHarddrinks.vue?vue&type=script&lang=js"

import exportComponent from "/home/projects/cc-gastro/htdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/BaseIconHarddrinks.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9a06b08a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9a06b08a', __exports__)) {
    console.log('reload')
    api.reload('9a06b08a', __exports__)
  }
  
  module.hot.accept("./BaseIconHarddrinks.vue?vue&type=template&id=9a06b08a", () => {
    console.log('re-render')
    api.rerender('9a06b08a', render)
  })

}


export default __exports__